import React, { PropsWithChildren } from 'react';
import { SimpleGrid, Text } from '@wegroup/design-system';

interface Props {
  title: string;
}

const PartyCreationFormSection: React.FC<PropsWithChildren<Props>> = ({
  children,
  title,
}) => {
  return (
    <SimpleGrid
      columns={{ base: 1, tablet: 2 }}
      columnGap={{ base: '0', tablet: '6' }}
      rowGap={{ base: '4', tablet: '4' }}
    >
      <Text
        gridColumn={{ base: '1', tablet: '-1/1' }}
        textStyle="normalBodyMedium"
        mb={{ base: '2', tablet: '0' }}
        mt={{ base: '4', tablet: '2' }}
      >
        {title}
      </Text>
      {children}
    </SimpleGrid>
  );
};

export default PartyCreationFormSection;
